export const getRowId = (data: any[], item: any) => {
  const result = data.filter((el) => el.rowId);
  if (result.length) {
    return result[0].rowId(item);
  }
  return null;
};
